export const defaultError = "Something was wrong!";
export const wrongCredential = "Wrong Credential!";
export const unexpectedError = "Unexpected error!";
